<template>
  <div class="work text-center" >
   <van-nav-bar title="已填报数据" style="position:fixed;width: 100%;"  @click-left="onClickLeft" left-text="返回" left-arrow>
    </van-nav-bar>
    <div class="pad-h-10 ">

      <van-cell :key="item.id" v-for="item in tblist">
        <div ><p style="color: blue;float: left;margin-right: 40px;">{{item.rqdate}}</p>  {{item.tbxmz}} <p style="color: blue;float: right;margin-right: 20px;">{{item.val}}</p> </div>
      </van-cell>

      <van-loading type="spinner" style="text-align: center" color="#1989fa" v-if="loading3" key="loading3" />
      <div class="course-table bg-f pad-10 radius-b-8" >
             </div>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      search: '',
      tabActive: 0,
      myList: Array,
      allList: Array,
      loading3: false,
      loading2: false,
      loading1: false,
      kblist: Array,
      tblist: Array,
      checkdata: false,
      checkdatatxt: '暂无数据',
      user: {},
      jwgglist: [],
      shrows: 0,
      hdsm: null,
      confirmInfo: false,
      showhd: false,
      checkedhd: false
    }
  },
  created () {
  //  this.getuser()
    // this.getnotislist();
    this.gettblist()
    // 更新消息数
    this.$emit('childClick', 'work')
  },
  methods: {
    tabChange (e) {
      console.log(e)
      this.tabActive = e
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    gettblist () {
      let that = this
      this.$ajax.get('/xm/tbdata/tblist?pageNum=1&pageSize=1000').then(res => {
        // console.log('gettblist:', res)
        that.tblist = res.rows.sort((a, b) => {
          if (a.rqdate == b.rqdate) {
            return b.px - a.px
          } else {
            return a.rqdate - b.rqdate
          }
        })

        that.checkdata = false
      })
    },
    /*    //公告通知
    getnotislist() {
      let that = this;
      this.$ajax.get('/appapi/appjwgg/index').then(function (rep) {
        if (rep.code == 200) {
          that.jwgglist = rep.newsList;
        }
      });
    }, */
    getuser () {
      // let that = this;
      // this.$ajax.get('/appapi/getInfo').then(function (res) {
      //   if (res.code == 200) {
      //     that.user = res.user;
      //     that.confirmInfo = res.confirmInfo;
      //     if(that.confirmInfo){
      //       that.hdsm = res.map.nr;
      //       that.showhd = true;
      //     }
      //   }
      // });
    },
    // 菜单名称过长的直接截取
    interceptmuname (val) {
      if (val.length > 4) {
        return val.substring(0, 4)
      } else {
        return val
      }
    }
  }
}
</script>
<style lang="less" scoped>
.work{
  /deep/.van-cell{
    border-radius: .5rem .5rem 0 0;
  }
  .custom-tab{
    p{
      padding: 0 .625rem;
      &.active{
        position: relative;
        &::after{
          position: absolute;
          background-color: #1989fa;
          content: '';
          height: 2px;
          width: 20px;
          left: 50%;
          bottom: -3px;
          margin-left: -10px;
          border-radius: 3px;
        }
      }
    }
  }
  .banner-box{
    .banner{
        height: 8.125rem;
        border-radius: .5rem .5rem 0 0;
        background: url('../../assets/images/banner.png')no-repeat center ;
        background-size: 100% auto;
        position: relative;
        /deep/.van-button{
          position: absolute;
          bottom: .625rem;
          left: .9375rem;
          height: 1.525rem;
        }
      }
  }
  .notice-swipe {
    height: 40px;
    line-height: 40px;
  }
}
.vansh-info {
  position: absolute;
  top: 5px;
  right: 6px;
  box-sizing: border-box;
  min-width: 16px;
  padding: 0 3px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  font-family: -apple-system-font,Helvetica Neue,Arial,sans-serif;
  line-height: 1.2;
  text-align: center;
  background-color: #ee0a24;
  border: 1px solid #fff;
  border-radius: 16px;
  -webkit-transform: translate(50%,-50%);
  transform: translate(50%,-50%);
  -webkit-transform-origin: 100%;
  transform-origin: 100%;
}
.vertical-center11 {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/SjTb/tblist.vue